export const STORAGEKEY = {
  token: "token",
  authData: "authData",
  userData: "ListenMonster",
  layoutData: "layoutData",
};
